/* BYON · Filtros en un solo DOM (agente Colecciones, R1 · C1-COL-03 / C1-COL-13)
 * Complementa assets/facets.js de Dawn sin reescribirlo:
 * - Parche de FacetFiltersForm: un solo parseo por respuesta; sin #FacetFiltersFormMobile (renderAdditionalElements
 *   de Dawn fallaría); grupos ocultos al día; foco devuelto al control equivalente; si la petición falla, navega a la
 *   URL filtrada en vez de dejar la grilla "cargando".
 * - Panel a pantalla completa bajo 990 px: lo abre "Filtrar" (byon-collection.js llama a ByonFacets.open) y lo cierran
 *   ×, "Ver N productos", Escape y el paso a desktop. Desde 990 px el mismo formulario es la barra lateral.
 * - "Ver N más" (valores en <template data-byon-more>) y chips de orden del panel.
 * - Medición K1: filter_apply (casillas y precio) y sort_change (chips del panel).
 * Contratos: byon-overlay-open y overflow-hidden en <body> mientras el panel está abierto (K7).
 */
(function () {
  if (window.ByonFacets) return;
  var doc = document;
  var desktop = window.matchMedia('(min-width: 990px)');
  var OTHER_OVERLAYS =
    'cart-drawer.active, .byon-mdrawer.is-open, #ByonSearch.is-open, quick-add-modal[open], [data-byon-sort-sheet]:not([hidden])';
  var FOCUSABLE =
    'summary, a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), [tabindex]:not([tabindex="-1"])';

  function track(name, data) {
    (window.byonTrack || function () {})(name, data);
  }

  function qs(selector, scope) {
    return (scope || doc).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || doc).querySelectorAll(selector));
  }

  function collectionKey() {
    var plp = qs('[data-byon-plp]');
    return (plp && plp.getAttribute('data-byon-collection')) || 'search';
  }

  function getRoot() {
    return qs('[data-byon-facets]');
  }

  function isOpen() {
    var root = getRoot();
    return !!(root && root.classList.contains('is-open'));
  }

  // Clase FacetFiltersForm de facets.js (la propiedad global del mismo nombre es el <form id="FacetFiltersForm">).
  function getFacets() {
    var ctor = window.customElements && window.customElements.get('facet-filters-form');
    return ctor && typeof ctor.renderPage === 'function' ? ctor : null;
  }

  /* ---------- Parche de facets.js ---------- */
  var parsed = { html: null, doc: null };

  function parse(html) {
    if (parsed.html !== html) {
      parsed.html = html;
      parsed.doc = new DOMParser().parseFromString(html, 'text/html');
    }
    return parsed.doc;
  }

  function describeFocus() {
    var el = doc.activeElement;
    var form = doc.getElementById('FacetFiltersForm');
    if (!el || !form || !form.contains(el)) return null;
    if (el.hasAttribute('data-byon-sort-drawer')) return { sort: true };
    if (el.name) return { name: el.name, value: el.type === 'checkbox' ? el.value : null };
    if (el.hasAttribute('data-byon-clear') || el.classList.contains('byon-facets__apply')) return { apply: true };
    var group = el.closest('.js-filter');
    return { index: group ? group.getAttribute('data-index') : null };
  }

  function isVisible(el) {
    return !!(el && el.getClientRects().length);
  }

  function restoreFocus(desc) {
    var active = doc.activeElement;
    if (!desc || (active && active !== doc.body && doc.contains(active))) return;
    var form = doc.getElementById('FacetFiltersForm');
    if (!form) return;
    var target = null;
    if (desc.sort) target = qs('[data-byon-sort-drawer][aria-pressed="true"]', form);
    if (!target && desc.name) {
      target = qsa('input', form).filter(function (input) {
        return input.name === desc.name && (desc.value === null || input.value === desc.value);
      })[0];
    }
    if (!target && desc.index) target = qs('.js-filter[data-index="' + desc.index + '"] > summary', form);
    if (!isVisible(target)) target = qs('.byon-facets__apply', form);
    if (!isVisible(target)) target = qs('.byon-facets__title', form);
    if (target) target.focus({ preventScroll: true });
  }

  function patch() {
    var F = getFacets();
    if (!F || F.__byonPatched) return;
    F.__byonPatched = true;
    var originalAdditional = F.renderAdditionalElements;

    F.renderSectionFromFetch = function (url, event) {
      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          F.filterData = (F.filterData || []).concat([{ html: html, url: url }]);
          F.renderFilters(html, event);
          F.renderProductGridContainer(html);
          F.renderProductCount(html);
          if (typeof window.initializeScrollAnimationTrigger === 'function') window.initializeScrollAnimationTrigger();
        })
        .catch(function () {
          var target = new URL(url, window.location.href);
          target.searchParams.delete('section_id');
          var params = target.searchParams.toString();
          window.location.href = target.pathname + (params ? '?' + params : '');
        });
    };

    F.renderFilters = function (html, event) {
      var source = parse(html);
      var focus = describeFocus();
      var eventFilter = event && event.target && event.target.closest ? event.target.closest('.js-filter') : null;
      var eventIndex = eventFilter && doc.contains(eventFilter) ? eventFilter.getAttribute('data-index') : null;
      qsa('#FacetFiltersForm .js-filter', source).forEach(function (fresh) {
        var index = fresh.getAttribute('data-index');
        var current = qs('#FacetFiltersForm .js-filter[data-index="' + index + '"]');
        if (!current) return;
        if (index === eventIndex) {
          // El grupo tocado conserva su DOM (y el foco); solo se actualiza el resumen "(n)".
          F.renderCounts(fresh, current);
        } else {
          current.innerHTML = fresh.innerHTML;
          current.hidden = fresh.hidden;
        }
      });
      F.renderActiveFacets(source);
      F.renderAdditionalElements(source);
      restoreFocus(focus);
    };

    F.renderAdditionalElements = function (html) {
      if (doc.getElementById('FacetFiltersFormMobile') && originalAdditional) originalAdditional.call(F, html);
    };

    F.renderProductGridContainer = function (html) {
      var fresh = parse(html).getElementById('ProductGridContainer');
      var container = doc.getElementById('ProductGridContainer');
      if (!fresh || !container) return;
      container.innerHTML = fresh.innerHTML;
      qsa('.scroll-trigger', container).forEach(function (el) {
        el.classList.add('scroll-trigger--cancel');
      });
    };

    F.renderProductCount = function (html) {
      var fresh = parse(html).getElementById('ProductCount');
      ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
        var el = doc.getElementById(id);
        if (!el) return;
        if (fresh && el.innerHTML !== fresh.innerHTML) el.innerHTML = fresh.innerHTML;
        el.classList.remove('loading');
      });
      syncOpeners();
    };
  }

  /* ---------- Panel (bajo 990 px) ---------- */
  var opener = null;

  function syncOpeners() {
    var open = isOpen();
    qsa('[data-byon-open-filters]').forEach(function (button) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function open(trigger) {
    var root = getRoot();
    if (!root) return;
    if (desktop.matches) {
      var first = qs('.byon-facets__summary', root);
      if (first) first.focus();
      return;
    }
    var title = qs('.byon-facets__title', root);
    opener = trigger || opener;
    root.classList.add('is-open');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    if (title && title.id) root.setAttribute('aria-labelledby', title.id);
    doc.body.classList.add('byon-overlay-open', 'overflow-hidden');
    syncOpeners();
    if (title) title.focus({ preventScroll: true });
  }

  function close(returnFocus) {
    var root = getRoot();
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.removeAttribute('role');
    root.removeAttribute('aria-modal');
    root.removeAttribute('aria-labelledby');
    doc.body.classList.remove('overflow-hidden');
    if (!qs(OTHER_OVERLAYS)) doc.body.classList.remove('byon-overlay-open');
    syncOpeners();
    var target = opener && doc.contains(opener) && isVisible(opener) ? opener : qsa('[data-byon-open-filters]').filter(isVisible)[0];
    opener = null;
    if (returnFocus && target) target.focus({ preventScroll: true });
  }

  function trapTab(event) {
    var root = getRoot();
    var items = qsa(FOCUSABLE, root).filter(isVisible);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = doc.activeElement;
    if (event.shiftKey && (active === first || !root.contains(active) || active === qs('.byon-facets__title', root))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !root.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---------- "Ver N más" ---------- */
  function showMore(button) {
    var group = button.closest('.byon-facets__group');
    var template = group && qs('template[data-byon-more]', group);
    var list = group && qs('.byon-facets__list', group);
    if (!template || !list) return;
    var fragment = template.content.cloneNode(true);
    var firstNew = qs('input', fragment);
    list.appendChild(fragment);
    template.remove();
    button.remove();
    if (firstNew) firstNew.focus();
  }

  /* ---------- Orden desde el panel ---------- */
  function sortFromPanel(button) {
    if (button.getAttribute('aria-pressed') === 'true') return;
    var value = button.getAttribute('data-byon-sort-drawer');
    qsa('[data-byon-sort-drawer]').forEach(function (chip) {
      chip.setAttribute('aria-pressed', chip === button ? 'true' : 'false');
    });
    track('sort_change', { sort_by: value, collection: collectionKey() });
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    var F = getFacets();
    if (F && doc.getElementById('product-grid')) F.renderPage(url.searchParams.toString());
    else window.location.href = url.toString();
  }

  /* ---------- Eventos ---------- */
  doc.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element) || !target.closest('[data-byon-facets]')) return;
    var trigger = target.closest('[data-byon-close-filters]');
    if (trigger) {
      event.preventDefault();
      close(true);
      // "Ver N productos": la grilla filtrada queda a la vista (si se había bajado antes de abrir el panel).
      if (trigger.classList.contains('byon-facets__apply') && window.ByonPLP && window.ByonPLP.scrollToResults) {
        window.ByonPLP.scrollToResults();
      }
      return;
    }
    trigger = target.closest('[data-byon-more-btn]');
    if (trigger) {
      event.preventDefault();
      showMore(trigger);
      return;
    }
    trigger = target.closest('[data-byon-sort-drawer]');
    if (trigger) {
      event.preventDefault();
      sortFromPanel(trigger);
    }
  });

  // K1: una casilla o un precio = 1 evento (facets.js aplica el cambio con su propio 'input').
  doc.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.name || !input.closest('#FacetFiltersForm')) return;
    if (input.type === 'checkbox') {
      track('filter_apply', {
        filter: input.name,
        value: input.value,
        action: input.checked ? 'add' : 'remove',
        collection: collectionKey(),
      });
    } else if (input.closest('price-range')) {
      track('filter_apply', {
        filter: input.name,
        value: input.value,
        action: input.value === '' ? 'remove' : 'add',
        collection: collectionKey(),
      });
    }
  });

  // Enter en el precio no recarga la página: facets.js ya aplica el cambio.
  doc.addEventListener('submit', function (event) {
    if (event.target && event.target.id === 'FacetFiltersForm') event.preventDefault();
  });

  doc.addEventListener('keydown', function (event) {
    if (!isOpen()) return;
    if (event.key === 'Escape' || event.code === 'Escape') {
      event.preventDefault();
      close(true);
    } else if (event.key === 'Tab') {
      trapTab(event);
    }
  });

  function onViewportChange() {
    if (desktop.matches) close(false);
  }
  if (desktop.addEventListener) desktop.addEventListener('change', onViewportChange);
  else if (desktop.addListener) desktop.addListener(onViewportChange);

  // K7: si otro componente quita byon-overlay-open mientras el panel sigue abierto, se repone.
  new MutationObserver(function () {
    if (isOpen() && !doc.body.classList.contains('byon-overlay-open')) doc.body.classList.add('byon-overlay-open');
  }).observe(doc.body, { attributes: true, attributeFilter: ['class'] });

  window.ByonFacets = {
    open: open,
    close: close,
    isOpen: isOpen,
    patch: patch,
  };

  patch();
  if (!getFacets() && window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('facet-filters-form').then(patch);
  }
})();